var createDiagFrame = function() {
    var defaultName = 'Diagnostic Quiz : ' + new Date().toDateString();
    var str = '<div class="modal-dialog" role="document">' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
        '<h4 class="modal-title" id="myModalLabel">Start Diagnostic Quiz</h4>' +
        '</div><!-- modal-header -->' +
        '<div class="modal-body">' +
        '<div class="form-group diag-name-group">' +
        '<label for="quiz-name">Name</label>' +
        '<input type="text" name="name" id="diag-name" class="form-control" value="'+ defaultName +'"/>' +
        '</div>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<div class="form-group"><button type="button" class="btn btn-default" id="create-diag-button">Create and GO!</button></div>' +
        '</div>' +
        '</div><!-- modal-content -->' +
        '</div><!-- modal-dialog -->';
    return $.parseHTML(str);
}

module.exports = createDiagFrame;


//////////////////
// WEBPACK FOOTER
// ./src/create_diag_frame.js
// module id = 300
// module chunks = 0